import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { PATH } from '../../../constants';
import { IconType } from '../../../types/icon.type';
import Button from '../../button/v2/button';
import { HStack } from '../../layouts/stack.layout';
import { isActiveLink } from '../desktop.navigation';
import { ALTERNATIVE_ICON } from '../navigationLink';

const styles = {
  container:
    'mobile:block tablet-lg:hidden z-10 sticky bottom-0 left-0 right-0 h-min bg-[#08080D] border-t border-dark-gray py-2.5 px-2 bg-black',
};

type Props = {
  path: string;
  icon: IconType;
  active: boolean;
};

function FooterNavigationOption({ path, icon, active }: Props) {
  return (
    <Link to={`/${path}`}>
      <Button
        color="secondary"
        asIcon={active ? ALTERNATIVE_ICON[icon] : icon}
        size="lg"
      />
    </Link>
  );
}

export default function FooterNavigation() {
  const { pathname } = useLocation();
  return (
    <footer className={styles.container}>
      <HStack extensions="w-full" justify="between">
        <FooterNavigationOption
          path=""
          icon="home"
          active={isActiveLink(pathname, PATH.HOME)}
        />
        <FooterNavigationOption
          path={PATH.DISCOVER}
          icon="discover"
          active={isActiveLink(pathname, PATH.DISCOVER)}
        />
        <FooterNavigationOption
          path={PATH.NOTIFICATIONS}
          icon="notifications"
          active={isActiveLink(pathname, PATH.NOTIFICATIONS)}
        />
        <FooterNavigationOption
          path={PATH.CHANNELS}
          icon="alt-spaces"
          active={isActiveLink(pathname, PATH.CHANNELS)}
        />
      </HStack>
    </footer>
  );
}
